// extracted by mini-css-extract-plugin
module.exports = {"container":"container___1-AFC","content":"content___3iD56","actions":"actions___3nfAZ","sidebarContent":"sidebarContent___2KvSS"};